import { render, staticRenderFns } from "./IndexAusentes.vue?vue&type=template&id=3e063bbc&"
import script from "./IndexAusentes.vue?vue&type=script&lang=js&"
export * from "./IndexAusentes.vue?vue&type=script&lang=js&"
import style0 from "./IndexAusentes.vue?vue&type=style&index=0&id=3e063bbc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports